export const teams = (state) => { return state.teams };

export const teamLoader = (state) => { return state.teamLoader };
